import React from "react";
import { Button } from "semantic-ui-react";
import useConveyorBoxHandlers from "../../../hooks/useConveyorBoxHandlers";

type Props = {};

const PrintNewLabelButton = (props: Props) => {
  const { onPrintNewLabelHandler } = useConveyorBoxHandlers();

  return (
    <Button
      content="Skriv ut ny fraktetikett"
      size="big"
      aria-label="skriv ut ny fraktetikett"
      icon="print"
      onClick={onPrintNewLabelHandler}
    />
  );
};

export default PrintNewLabelButton;
